"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ServiceRegistry = _interopRequireDefault(require("../../../../util/ServiceRegistry"));
var _react = _interopRequireDefault(require("react"));
var _PropTypeCustomAction = require("../prop-type-custom-action/PropTypeCustomAction");
var _CustomActions = _interopRequireDefault(require("./custom-actions/CustomActions"));
var _SideMenuCallToAction = _interopRequireDefault(require("./call-to-action/SideMenuCallToAction"));
var _Branding = _interopRequireDefault(require("./branding/Branding"));
var _HeaderFileInfoContainer = _interopRequireDefault(require("../../header-file-info/container/HeaderFileInfoContainer"));
var _FullScreenIcon = _interopRequireDefault(require("../../icons/full-screen/FullScreenIcon"));
var _ViewMode = _interopRequireWildcard(require("../../../../constants/ViewMode"));
var _LightBoxExitPDFViewerButton = _interopRequireDefault(require("./light-box-exit-pdf-viewer-button/LightBoxExitPDFViewerButton"));
var _ModernViewerCustomActions = _interopRequireDefault(require("./custom-actions/ModernViewerCustomActions"));
var _DropdownButton = _interopRequireDefault(require("@react/react-spectrum/DropdownButton"));
var _Menu = require("@react/react-spectrum/Menu");
var _Events = require("../../../../constants/Events");
var _ComponentRegistry = _interopRequireDefault(require("../../../../util/ComponentRegistry"));
require("!style-loader!css-loader!./HeaderView.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

class HeaderView extends _react.default.Component {
  getEditView() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  getHomeButton() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  _handleFullScreen() {
    const config = _ServiceRegistry.default.getService("AppStore").getConfig();
    if (config.isViewSDKPublic) {
      const appStore = _ServiceRegistry.default.getService("AppStore");
      if (!appStore.enableModernViewer) {
        /* Full screen icon in HUD in updated by
        FullScreenManager in case of modern viewer */
        _ServiceRegistry.default.getService("UIHandler").updateFSIconInHud();
      }
    }
  }
  getLeftPanelToggleButton() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  getSideMenu({
    sideMenuActions
  }) {
    return /*#__PURE__*/_react.default.createElement("div", {
      role: "presentation",
      className: (0, _classnames.default)(["sdk-HeaderView-navSection", "sdk-HeaderView-sideMenuButton"])
    }, /*#__PURE__*/_react.default.createElement(_SideMenuCallToAction.default, {
      sideMenuActions: sideMenuActions
    }));
  }
  render() {
    const {
      topBarActions,
      sideMenuActions,
      topBarAnnotationTools,
      previewRef,
      viewMode: viewModeProp,
      makeToolsInactive,
      shouldDisplayReadAloudTools
    } = this.props;
    const appStore = _ServiceRegistry.default.getService("AppStore");
    if (shouldDisplayReadAloudTools) {
      const readAloudNonMainComponentIds = ["readAloudIcon", "readAloudFileName", "readAloudStop"];
      // eslint-disable-next-line max-len
      const topBarBrandingActions = topBarActions.filter(action => action.id === "readAloudIcon" || action.id === "readAloudFileName");
      const topBarCloseActions = topBarActions.filter(action => action.id === "readAloudStop");
      const topBarMainActions = topBarActions.filter(action => !readAloudNonMainComponentIds.includes(action.id));
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(["sdk-HeaderView-header", "sdk-HeaderView-header-modernViewer"]),
        ref: ref => this.props.setRef(ref)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "readAloudBranding"
      }, topBarBrandingActions.map(readAloudActions => readAloudActions.Component)), /*#__PURE__*/_react.default.createElement("div", {
        className: "readAloudComponent"
      }, topBarMainActions.map(readAloudActions => readAloudActions.Component)), /*#__PURE__*/_react.default.createElement("div", {
        className: "readAloudClose"
      }, topBarCloseActions.map(readAloudActions => readAloudActions.Component)));
    }
    const editView = this.getEditView();
    const sideMenu = this.getSideMenu({
      sideMenuActions
    });
    this._handleFullScreen();
    const ActionsView = () => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, appStore.showViewMode && /*#__PURE__*/_react.default.createElement(_DropdownButton.default, {
      icon: _ComponentRegistry.default.getComponent(viewModeProp === _ViewMode.default.SINGLE_PAGE ? "SinglePageIcon" : "ContinuousIcon"),
      alignRight: true,
      onSelect: viewMode => {
        if (viewModeProp !== viewMode) {
          previewRef.getPublicApis().then(api => {
            api.document.setViewMode(_ViewMode.InternalViewMode[viewMode] || viewMode);
            _ServiceRegistry.default.getService("EventsService").sendEvent(_Events.FilePreviewEvents.VIEW_MODE_CHANGE, viewMode);
          });
          appStore.setCurrentViewMode(viewMode);
        }
      }
    }, /*#__PURE__*/_react.default.createElement(_Menu.MenuItem, {
      selected: viewModeProp === _ViewMode.default.SINGLE_PAGE,
      icon: _ComponentRegistry.default.getComponent("SinglePageIcon"),
      value: _ViewMode.default.SINGLE_PAGE
    }, appStore.intl.formatMessage({
      id: "viewMode.single"
    })), /*#__PURE__*/_react.default.createElement(_Menu.MenuItem, {
      selected: viewModeProp === _ViewMode.default.CONTINUOUS,
      icon: _ComponentRegistry.default.getComponent("ContinuousIcon"),
      value: _ViewMode.default.CONTINUOUS
    }, appStore.intl.formatMessage({
      id: "viewMode.continuous"
    }))), topBarAnnotationTools && topBarAnnotationTools.length > 0 && /*#__PURE__*/_react.default.createElement(_ModernViewerCustomActions.default, {
      actions: topBarAnnotationTools
    }), topBarActions && topBarActions.length > 0 && /*#__PURE__*/_react.default.createElement(_CustomActions.default, {
      className: "sdk-HeaderView-navSection",
      actions: topBarActions,
      makeToolsInactive: makeToolsInactive
    }), sideMenu, editView, appStore.configStore.showFullScreen && /*#__PURE__*/_react.default.createElement(_FullScreenIcon.default, {
      fromTopBar: true
    }), appStore.configStore.exitPDFViewerType === _ViewMode.LightBoxExitPDFViewerType.CLOSE && /*#__PURE__*/_react.default.createElement(_LightBoxExitPDFViewerButton.default, null));
    let leftFileinfoClass = "";
    if (appStore.configStore.getConfig().leftAlignFileName) {
      if (appStore.showBrandingInHeader || appStore.getActionConfig("preview").showPreviewHomeButton) {
        if (appStore.configStore.exitPDFViewerType === _ViewMode.LightBoxExitPDFViewerType.RETURN) {
          leftFileinfoClass = "sdk-HeaderView-leftFileinfoWithBrandingAndLeftButton";
        } else {
          leftFileinfoClass = "sdk-HeaderView-leftFileinfoWithBranding";
        }
      } else {
        leftFileinfoClass = "sdk-HeaderView-leftFileinfoWithoutBranding";
      }
    }
    const headersClassList = ["sdk-HeaderView-header"];
    if (appStore.enableModernViewer) {
      headersClassList.push("sdk-HeaderView-header-modernViewer");
    }
    if (appStore.isHidingHeader) {
      if (!appStore.searchOpen) {
        headersClassList.push("sdk-HeaderView-headerForSizedContainer");
      } else {
        headersClassList.push("sdk-HeaderView-headerForSizedContainerWithSearch");
      }
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(headersClassList),
      ref: ref => this.props.setRef(ref)
    }, appStore.configStore.exitPDFViewerType === _ViewMode.LightBoxExitPDFViewerType.RETURN && /*#__PURE__*/_react.default.createElement(_LightBoxExitPDFViewerButton.default, null), appStore.showBrandingInHeader && /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(["sdk-HeaderView-navSection", "sdk-HeaderView-branding"]),
      role: "presentation"
    }, /*#__PURE__*/_react.default.createElement(_Branding.default, null)), appStore.getActionConfig("preview").showPreviewHomeButton && this.getHomeButton(), this.getLeftPanelToggleButton(), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(["sdk-HeaderView-navSection", "sdk-HeaderView-dummyDiv"]),
      role: "presentation"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(["sdk-HeaderView-navSection", "sdk-HeaderView-centreInfo", leftFileinfoClass]),
      role: "presentation"
    }, /*#__PURE__*/_react.default.createElement(_HeaderFileInfoContainer.default, this.props)), (appStore.isInPreview || appStore.isInEdit) && /*#__PURE__*/_react.default.createElement(ActionsView, null), !appStore.isInPreview && this.getSideMenu({
      sideMenuActions: []
    }));
  }
}
exports.default = HeaderView;
HeaderView.propTypes = {
  topBarActions: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_PropTypeCustomAction.propTypeJsonCustomAction, _PropTypeCustomAction.propTypeReactCustomAction])),
  sideMenuActions: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_PropTypeCustomAction.propTypeJsonCustomAction, _PropTypeCustomAction.propTypeReactCustomAction])),
  topBarAnnotationTools: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_PropTypeCustomAction.propTypeJsonCustomAction, _PropTypeCustomAction.propTypeReactCustomAction])),
  inFullScreen: _propTypes.default.bool.isRequired,
  previewRef: _propTypes.default.objectOf(_propTypes.default.any),
  setRef: _propTypes.default.func.isRequired,
  viewMode: _propTypes.default.string,
  makeToolsInactive: _propTypes.default.bool,
  shouldDisplayReadAloudTools: _propTypes.default.bool
};
HeaderView.defaultProps = {
  topBarActions: [],
  sideMenuActions: [],
  topBarAnnotationTools: [],
  previewRef: null,
  viewMode: null,
  makeToolsInactive: false,
  shouldDisplayReadAloudTools: false
};